import locationDetailsSlice
    from "@pages/StudentsManagement/Students/components/StudentsSettingsPages/LocationDetails/store/locationDetailsSlice";
import admissionBasisSlice
    from "@pages/StudentsManagement/Students/components/StudentsSettingsPages/AdmissionBasis/store/admissionBasisSlice";
import disabilityGroupSlice
    from "@pages/StudentsManagement/Students/components/StudentsSettingsPages/DisabilityGroup/store/disabilityGroupSlice";
import socialStatusSlice
    from "@pages/StudentsManagement/Students/components/StudentsSettingsPages/SocialStatus/store/socialStatusSlice";
import studentInstituteSlice
    from "@pages/StudentsManagement/Students/components/StudentsSettingsPages/StudentInstitute/store/studentInstituteSlice";
import studyPaymentSlice from "@pages/StudentsManagement/StudyPaymentOptions/store/studyPaymentSlice";
import studentsStatusSlice
    from "@pages/StudentsManagement/Students/components/StudentsSettingsPages/StudentsStatus/store/studentsStatusSlice";
import studentsSlice from "@pages/StudentsManagement/Students/store/studentsSlice";

export const studentsReducer = {
    locationDetails:locationDetailsSlice.reducer,
    admissionBasis:admissionBasisSlice.reducer,
    disabilityGroup:disabilityGroupSlice.reducer,
    socialStatus:socialStatusSlice.reducer,
    studentInstitute:studentInstituteSlice.reducer,
    studyPayment:studyPaymentSlice.reducer,
    studentsStatus:studentsStatusSlice.reducer,
    students:studentsSlice.reducer,
}